import DataExportFormatter from './DataExportFormatter';
import {hasFeatureFlag} from '../FeatureUtil';
import Util from '../util';

// entire class will be removed with the _new_csv_format flag - see notes on individual methods
export default class ReportFormatter extends DataExportFormatter {
	_new_csv_format;

	constructor(intl) {
		super(intl);
		this._new_csv_format = hasFeatureFlag('new_csv_format');
	}

	// will be removed with new_csv_format flag
	_formatCurrency(amount) {
		return this._new_csv_format ? super._formatCurrency(amount) : amount || 0;
	}

	// will be removed with new_csv_format flag
	_minutesToHoursAndMinuteString(minutes) {
		return Util.convertMinutesToFullHour(minutes || 0, this._intl);
	}

	// will be removed with new_csv_format flag
	_formatTime(minutes) {
		return this._new_csv_format ? super._formatTime(minutes) : this._minutesToHoursAndMinuteString(minutes);
	}

	// entire method should be removed with new_csv_format flag
	_formatPercentageFromFraction(fraction) {
		return this._new_csv_format ? super._formatPercentageFromFraction(fraction ) : Util.getFormattedPercentage(fraction || 0, this._intl);
	}
}
